/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PackageSubscriptionDiscount from './package-subscription-discount';
import PackageSubscriptionDiscountDetail from './package-subscription-discount-detail';
import PackageSubscriptionDiscountUpdate from './package-subscription-discount-update';
import PackageSubscriptionDiscountDeleteDialog from './package-subscription-discount-delete-dialog';

const PackageSubscriptionDiscountRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PackageSubscriptionDiscount />} />
    <Route path="new" element={<PackageSubscriptionDiscountUpdate />} />
    <Route path=":id">
      <Route index element={<PackageSubscriptionDiscountDetail />} />
      <Route path="edit" element={<PackageSubscriptionDiscountUpdate />} />
      <Route path="delete" element={<PackageSubscriptionDiscountDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PackageSubscriptionDiscountRoutes;
